import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authGuard } from './shared/services';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { SecurePageComponent } from './pages/secure-page/secure-page.component';
import { InventoryListComponent } from './pages/inventory-list/inventory-list.component';
import { SaleTimeComponent } from './pages/sale/sale-time/sale-time.component';
import { LazadaOrderPageComponent } from './pages/orders/lazada/lazada-order-page.component';
import { ShopeeGen4OrderPageComponent } from './pages/orders/shopee-general4/shopee-general4-order-page.component';
import { ShopeeGenLogicOrderPageComponent } from './pages/orders/shopee-genlogic/shopee-genlogic-order-page.component';
import { TiktokOrderPageComponent } from './pages/orders/tiktok/tiktok-order-page.component';
import { AllOrdersComponent } from './pages/orders/all-orders/all-orders.component';
import { QuickOrdersComponent } from './pages/orders/quick-orders/quick-orders.component';
import { ReturnPackagesComponent } from './pages/orders/return-packages/return-packages.component';
import { ReturnInspectionComponent } from './pages/orders/return-inspection/return-inspection.component';
import { ApiAuthSettingsComponent } from './pages/settings/api-auth-settings/api-auth-settings.component';
import { QuoteGeneratorComponent } from './pages/quote-generator/quote-generator.component';
import { TempDeliveryNoteComponent } from './pages/temp-delivery-note/temp-delivery-note.component';
import { ReceiptNoteComponent } from './pages/receipt-note/receipt-note.component';
import { CreateTaxInvoiceComponent } from './pages/tax-invoice/components/create-tax-invoice/create-tax-invoice.component';
import { ServiceMonComponent } from './pages/service-mon/service-mon.component';
import { CrawlerMonComponent } from './pages/crawler-mon/crawler-mon.component';
import { ReorderingComponent } from './pages/reordering/reordering.component';
import { LongTermPausedComponent } from './pages/reordering/long-term-paused/long-term-paused.component';
import { Supplier1688PageComponent } from './pages/reordering/supplier-1688-page/supplier-1688-page.component';
import { OutputTaxSummaryComponent } from './pages/tax-invoice/components/output-tax-summary/output-tax-summary.component';
import { RevenueFeesComponent } from './pages/finance/revenue-fees/revenue-fees.component';
import { EmbededComponent } from './pages/embeded/embeded.component';
import { ReceiptInfoFillerComponent } from './pages/embeded/pages/receipt-info-filler/receipt-info-filler.component';
import { RequestTaxInvoiceComponent } from './pages/tax-invoice-request/components/request-tax-invoice/request-tax-invoice.component';
import { ManageRequestDataComponent } from './pages/tax-invoice-request/components/manage-request-data/manage-request-data.component';
import { PriceCalFillerComponent } from './pages/embeded/pages/price-cal-filler/price-cal-filler.component';
import { PriceSetFillerComponent } from './pages/embeded/pages/price-set-filler/price-set-filler.component';

const routes: Routes = [
    {
        path: 'login',
        canActivate: [authGuard],
        component: LoginPageComponent,
    },
    {
        path: 'secure',
        canActivate: [authGuard],
        component: SecurePageComponent,
        children: [
            {
                path: 'orders/quick',
                component: QuickOrdersComponent,
                data: { title: 'Quick Orders' },
            },
            {
                path: 'orders/lazada',
                component: LazadaOrderPageComponent,
                data: { title: 'Lazada Orders' },
            },
            {
                path: 'orders/shopee/gen4',
                component: ShopeeGen4OrderPageComponent,
                data: { title: 'Shopee Orders (Gen4)' },
            },
            {
                path: 'orders/shopee/genlogic',
                component: ShopeeGenLogicOrderPageComponent,
                data: { title: 'Shopee Orders (GenLogic)' },
            },
            {
                path: 'orders/tiktok',
                component: TiktokOrderPageComponent,
                data: { title: 'TikTok Orders' },
            },
            {
                path: 'orders/all',
                component: AllOrdersComponent,
                data: { title: 'All Orders' },
            },
            {
                path: 'orders/returns',
                component: ReturnPackagesComponent,
                data: { title: 'พัสดุคืนสินค้า' },
            },
            {
                path: 'orders/returns/inspection',
                component: ReturnInspectionComponent,
                data: { title: 'ตรวจสอบสินค้าคืน' },
            },
            {
                path: 'inventory/inventory-list',
                component: InventoryListComponent,
            },
            {
                path: 'sale/time',
                component: SaleTimeComponent,
            },
            {
                path: 'settings/api-auth',
                component: ApiAuthSettingsComponent,
            },
            {
                path: 'settings/svc-mon',
                component: ServiceMonComponent,
            },
            {
                path: 'settings/crawler-mon',
                component: CrawlerMonComponent,
                data: { title: 'Crawler Monitor' },
            },
            {
                path: 'billings/quote-generator',
                component: QuoteGeneratorComponent,
            },
            {
                path: 'billings/tax-invoice',
                component: CreateTaxInvoiceComponent,
            },
            {
                path: 'billings/temp-delivery-note',
                component: TempDeliveryNoteComponent,
            },
            {
                path: 'billings/receipt-note',
                component: ReceiptNoteComponent,
                data: { title: 'Receipt Note' },
            },
            {
                path: 'utilities/reordering',
                component: ReorderingComponent,
            },
            {
                path: 'utilities/reordering/long-term',
                component: LongTermPausedComponent,
                data: { title: 'พักสั่งซื้อระยะยาว' },
            },
            {
                path: 'utilities/reordering/1688',
                component: Supplier1688PageComponent,
                data: { title: 'ข้อมูล 1688' },
            },
            {
                path: 'tax/output-tax/summary',
                component: OutputTaxSummaryComponent,
            },
            {
                path: 'finance/revenue-fees',
                component: RevenueFeesComponent,
            },
            {
                path: 'tax/input-tax/req/create',
                component: RequestTaxInvoiceComponent,
            },
            {
                path: 'tax/input-tax/req/manage',
                component: ManageRequestDataComponent,
            },
        ],
    },
    {
        path: 'embeded',
        component: EmbededComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'ctp-finder',
                component: ReceiptInfoFillerComponent,
            },
            {
                path: 'price-cal',
                component: PriceCalFillerComponent,
            },
            {
                path: 'price-set',
                component: PriceSetFillerComponent,
            },
        ],
    },
    { path: '**', redirectTo: 'secure/orders/all' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {}
